/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBeneficiaryCertificateAssetCountQueryVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  contentType?: Types.InputMaybe<Types.AssetContentTypeEnum>;
  labeled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type IBeneficiaryCertificateAssetCountQuery = {
  __typename?: 'Query';
  beneficiaryCertificateAssetCount: { __typename?: 'AssetCount'; count: number; latestDeposit?: any | null };
};

export const BeneficiaryCertificateAssetCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'beneficiaryCertificateAssetCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetContentTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'labeled' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'beneficiaryCertificateAssetCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'softwareEscrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'labeled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'labeled' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latestDeposit' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBeneficiaryCertificateAssetCountQuery, IBeneficiaryCertificateAssetCountQueryVariables>;
